// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/new-process/new-process.component.scss
// module id = 573
// module chunks = 0